import React, { useMemo, useEffect, useState } from "react";

import { initialState } from "./useAppReducer";
import { ActionType, StateType, actionTypes } from "../types/state";

export function useAppStore([state, dispatch]: [StateType, React.Dispatch<ActionType>]) {
  const keyLocal = "appInfo";
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    const local = localStorage.getItem(keyLocal);
    const localJSON = local ? JSON.parse(local) : null;
    if (localJSON) {
      dispatch({
        type: actionTypes.setAllState,
        value: localJSON,
      });
    } else {
      localStorage.setItem(keyLocal, JSON.stringify(state));
      dispatch({
        type: actionTypes.setAllState,
        value: state,
      });
    }
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (state !== initialState) {
      localStorage.setItem(keyLocal, JSON.stringify(state));
    }
  }, [state]);

  const contextValue = useMemo(
    () => ({ state, dispatch, isHydrated }),
    [state, dispatch, isHydrated]
  );
  return contextValue;
}
